import React from "react";
import { NavLink } from "react-router-dom";

function Navigation() {
  return (
    <div className="navigation" style={{position: 'sticky', top: 0}}>
      <nav className="navbar navbar-expand navbar-dark bg-dark">
        <div className="container">
          <NavLink className="navbar-brand" to="/">
            TinkRNG
          </NavLink>
          <div>
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <NavLink className="nav-link" to="/">
                  Home
                  <span className="sr-only">(current)</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/minting">
                  Minting
                  <span className="sr-only">(current)</span>
                </NavLink>
              </li>
              <li>
                <a href="/termsofuse.pdf" className="nav-link" alt="alt text" target="_blank" rel="noopener noreferrer">Terms of Use</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navigation;
